// Read in the browser as well as on the BFF. Each variable is referenced by its
// literal name so Next can inline the NEXT_PUBLIC_ values into the client bundle.
export const CONSTRUCTOR_API_BASE =
  process.env.NEXT_PUBLIC_CONSTRUCTOR_API_BASE ?? 'https://ac.cnstrc.com'

export const CONSTRUCTOR_INDEX_KEYS: Record<string, string | undefined> = {
  'en-US': process.env.NEXT_PUBLIC_CONSTRUCTOR_INDEX_KEY_EN_US,
  'en-GB': process.env.NEXT_PUBLIC_CONSTRUCTOR_INDEX_KEY_EN_GB,
  'de-DE': process.env.NEXT_PUBLIC_CONSTRUCTOR_INDEX_KEY_DE_DE,
  'es-ES': process.env.NEXT_PUBLIC_CONSTRUCTOR_INDEX_KEY_ES_ES,
  'es-US': process.env.NEXT_PUBLIC_CONSTRUCTOR_INDEX_KEY_ES_US,
  'fr-FR': process.env.NEXT_PUBLIC_CONSTRUCTOR_INDEX_KEY_FR_FR,
  'it-IT': process.env.NEXT_PUBLIC_CONSTRUCTOR_INDEX_KEY_IT_IT,
}

/**
 * Constructor recommendation pod IDs.
 *
 * A pod is tuned independently in the Constructor dashboard, so sharing one with
 * another placement means inheriting its changes. M-tag deploys separately from
 * MB3 and deliberately owns its own pods; the MB3 registry lives in
 * `src/common/api/constructor/podIds.ts` in mb3-frontend.
 */
export const CONSTRUCTOR_POD_IDS = {
  /** Scan a tag -> Similar tab. */
  findSimilar: 'mtag-find-similar',
  /** Scan a tag -> Pairs With tab. */
  pairsWith: 'mtag-pairs-with',
} as const

// Results per request when the caller doesn't pass resultsPerPage. Shared so the
// browser and the BFF fallback return the same number of items.
export const DEFAULT_RESULTS_PER_PAGE = {
  findSimilar: 12,
  pairsWith: 50,
} as const

export function getConstructorIndexKey(
  locale: string,
  indexKeys: Record<string, string | undefined> = CONSTRUCTOR_INDEX_KEYS,
): string {
  const key = indexKeys[locale] ?? indexKeys['en-US']

  if (!key) {
    throw new Error(
      `No Constructor.io index key configured for locale: ${locale}`,
    )
  }

  return key
}
